// extracted by mini-css-extract-plugin
module.exports = {"container":"used-by-item_container__7u8cX","textNumber":"used-by-item_textNumber__zbtF_","subNumber":"used-by-item_subNumber__LsQsP","video-spin":"used-by-item_video-spin__tNDiQ"};